import { inject, Provider, signal } from '@angular/core';

import { Cb2PreviewStateService } from '@core/services/cb2-preview/cb2-preview-state.service';

import {
  SUGGESTION_CARDS_BLOCK_DATA_SOURCE,
  SuggestionCardsBlockDataSource,
  SUGGESTION_CARDS_BLOCK_SUGGESTIONS_SET,
} from './suggestion-cards-block-view-model';
import { SuggestionCardsBlockPreviewDataSource } from './suggestion-cards-block-preview-data-source';
import { SuggestionCardsBlockStoreDataSource } from './suggestion-cards-block-store-data-source';

export function provideSuggestionCardsBlockDataSource(): Provider[] {
  return [
    {
      provide: SUGGESTION_CARDS_BLOCK_SUGGESTIONS_SET,
      useFactory: () => signal<string | undefined>(undefined),
    },
    SuggestionCardsBlockStoreDataSource,
    SuggestionCardsBlockPreviewDataSource,
    {
      provide: SUGGESTION_CARDS_BLOCK_DATA_SOURCE,
      useFactory: (): SuggestionCardsBlockDataSource => {
        const previewState = inject(Cb2PreviewStateService);
        return previewState.isActive()
          ? inject(SuggestionCardsBlockPreviewDataSource)
          : inject(SuggestionCardsBlockStoreDataSource);
      },
    },
  ];
}
